import * as React from 'react'

export const SvgIconSuccess = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} {...props}>
    <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM15.293 5.293L8.003 12.586L4.707 9.293L3.293 10.707L8.003 15.414L16.707 6.707L15.293 5.293V5.293Z" />
  </svg>
)

export default SvgIconSuccess
